import { getAudioConstraints } from "src/modules/rtc/media-constraints";
import Microphone from "./lib/Microphone";
import AudioEncoder from "./lib/AudioEncoder";
import SendBuffer from "./lib/SendBuffer";
import ToneGenerator from "../ToneGenerator";

const log = window.require("electron-log");

export default async function createOpusRecorder({ onFlush }) {
  let microphone = new Microphone();
  let encoder = new AudioEncoder();
  let toneGenerator = new ToneGenerator();
  let isToneGeneratorEnabled = false;
  let sendBuffer = new SendBuffer({ flushSize: 200 });

  const audioConstraints = getAudioConstraints();
  const { noiseMeter, samplingRate, numOfChannels } = await microphone.open(
    audioConstraints
  );

  const encoderConfig = {
    sampling_rate: samplingRate,
    num_of_channels: numOfChannels,
    params: {
      application: 2048,
      sampling_rate: 16000,
      frame_duration: 20
    }
  };

  await encoder.setup(encoderConfig);

  sendBuffer.onFlush = onFlush;

  microphone.onData = async (buffer) => {
    if (encoder == null) {
      return;
    }
    if (isToneGeneratorEnabled) {
      toneGenerator.generate(buffer.samples);
    }
    const packets = await encoder.encode(buffer);
    if (sendBuffer == null) {
      return;
    }
    if (packets.length === 0) return;

    packets.forEach((packet) => {
      sendBuffer.append(packet);
    });
  };

  return {
    noiseMeter,
    stop: async () => {
      try {
        await microphone.stop();
      } catch (error) {
        log.error(error);
      }
      sendBuffer && sendBuffer.flush();
    },
    resume: () => microphone.resume(),
    destroy: () => {
      microphone && microphone.opened && microphone.close();
      microphone = null;
      encoder = null;
      sendBuffer && sendBuffer.flush();
      sendBuffer = null;
    }
  };
}
